export const currentProcessingNocFileBase = {
  package_type: "noc",
  packageID: null,
  email: "",
  is_subuser: "",
  user_document_token: "",
  status: "",
  payments: [],
  document_location: {},
  signer: {
    name: "owner",
    label: "Property Owner - Grantor",
    address: "",
    phone_number: "",
    email: "",
    PERSON: {
      first_name: "",
      middle_name: "",
      last_name: "",
    },
    ORGANIZATION: {
      nameUnparsed: "",
    },
  },
  contractor: {
    name: "contractor",
    label: "Contractor - Grantee",
    address: "",
    phone_number: "",
    email: "",
    PERSON: {
      first_name: "",
      middle_name: "",
      last_name: "",
      business_name: "",
    },
    ORGANIZATION: {
      nameUnparsed: "",
    },
  },
  processing_permit: {},
  document: {
    formID: null,
    document_name: null,
    pdf_url: "",
    img_urls: [],
    cleaned_file_name: "",
    actions: {
      notarize: false,
      record: false,
    },
    signer_fields: [],
    signature: {},
    tempFields: {
      formFields: [],
      selectedFormField: null,
      selectedExtraFields: [],
      currentDocument: {
        base64File: null,
        formName: "",
        fileName: "",
        files: [],
        numPages: 0,
        pageNumber: 1,
        pdfSize: 1000,
        scaleFactor: 1,
      },
      formFieldTools: {
        textField: {
          active: false,
          values: [],
          name: "text_field",
          type: "PDFTextField",
          group: "g",
          disabled: false,
        },
        checkbox: {
          active: false,
          values: [],
          name: "checkbox",
          type: "PDFCheckBox",
          group: "g",
          disabled: false,
        },
        radio: {
          active: false,
          values: [],
          name: "radio",
          type: "PDFRadioGroup",
          group: "g",
          disabled: false,
        },
        date: {
          active: false,
          values: [],
          name: "date_field",
          type: "PDFTextField",
          group: "g",
          disabled: false,
        },
        notarySeal_a: {
          active: false,
          values: [],
          name: "notary_seal_a",
          type: "PDFTextField",
          group: "n",
          disabled: false,
        },
        notarySignature_a: {
          active: false,
          values: [],
          name: "notary_sign_a",
          type: "PDFTextField",
          group: "n",
          disabled: false,
        },
        signatureA: {
          active: false,
          values: [],
          name: "sign_a",
          type: "PDFTextField",
          group: "s",
          disabled: false,
        },
      },
    },
  },
};
